import { Dialog, DIALOG_SLOTS, TYPES } from '@/packages/ev-dialogs/dialogs';
import { createOverlayRegistry } from '@/packages/ev-overlays/registry';

export default {
  install(Vue) {
    const registry = createOverlayRegistry(Vue);

    const addNewDialog = (type, options = {}) => {
      const dialog = new Dialog({ ...options, type });
      return registry.add(dialog);
    };

    Vue.prototype.$dialogs = {
      confirm: (options) => addNewDialog(TYPES.confirm, options),
      form: (options = {}) => addNewDialog(TYPES.form, options),
      portal: (options = {}) => addNewDialog(TYPES.portal, options),
      list: registry.list,
      get: registry.get,
      has: registry.has,
      close: registry.close,
      remove: registry.remove,
      resetAll: registry.resetAll,
      types: TYPES,
      slots: DIALOG_SLOTS,
    };
  },
};
